import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.function.name";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '../../../services/apiService';
import { mapState } from 'vuex';
import formMixin from '../formMixin';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import set from 'lodash/set';
export default {
  name: 'NiotaClassicGwMgmtForm',
  mixins: [formMixin],
  props: {
    accounts: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    isOpen: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      addressObject: {
        address: '',
        coordinates: [null, null]
      },
      originatorDialog: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])), {}, {
    isSuperSystemAdmin: function isSuperSystemAdmin() {
      return this.permissions['super.system.manage'];
    },
    formCardButtons: function formCardButtons() {
      if (this.isIotHubManager) {
        return [{
          icon: 'fas fa-save',
          title: this.formItem.id ? this.$i18n_t('Common.save') : this.$i18n_t('Common.saveAndCreate'),
          type: this.isIotHubManager ? 'submit' : 'button',
          valid: this.isIotHubManager ? undefined : false
        }, {
          icon: 'fal fa-times',
          color: 'danger',
          action: 'close',
          tooltip: this.$i18n_t('Common.cancel')
        }];
      }

      return [{
        icon: 'fal fa-times',
        color: 'danger',
        action: 'close',
        tooltip: this.$i18n_t('Common.cancel')
      }];
    },
    coordinateLookup: function coordinateLookup() {
      return get(this.formItem, 'properties.coordinateMode') !== 'manual';
    },
    integerRule: function integerRule() {
      var _this = this;

      return [function (v) {
        return !!v && !isNaN(v) || _this.$i18n_t('DigitalTwin.DigitalTwin.states.randomMustBeNumber');
      }];
    },
    numberRule: function numberRule() {
      var _this2 = this;

      return [function (v) {
        return !!v && /^([0-9]+)\.?([0-9]*)$/.exec(v) !== null || parseFloat(v) === 0 || _this2.$i18n_t('DigitalTwin.DigitalTwin.states.randomMustBeNumber');
      }];
    },
    thresholdAlertRule: function thresholdAlertRule() {
      var _this3 = this;

      return this.numberRule.concat([function (v) {
        return parseFloat(v) >= 1 || _this3.$i18n_t('NiotaClassic.GWMonitoring.form.alertMin1Hour');
      }]);
    }
  }),
  created: function created() {
    this.formItem = cloneDeep(this.editedItem);

    if (!this.formItem.properties) {
      this.formItem.properties = {};
    }

    if (!this.formItem.properties.threshold) {
      this.formItem.properties.threshold = {
        green: 5,
        yellow: 12
      };
    }

    this.setAddressObject();
  },
  methods: {
    selectedOriginator: function selectedOriginator(originator) {
      if (!get(this.formItem, 'properties')) {
        set(this.formItem, 'properties', {});
      }

      this.formItem.properties.originator = {
        id: originator.id
      };
      this.formItem.properties.datasource = {
        id: get(originator, 'datasource.id')
      };
      this.originatorDialog = false;
    },
    formatLastPacketTime: function formatLastPacketTime(duration) {
      var durationHours = Math.floor(duration);
      var durationMinutes = Math.round(duration * 60) - durationHours * 60;
      var hoursString = this.$i18n_tc('NiotaClassic.GWMonitoring.hours', durationHours, {
        n: durationHours
      });
      var minutesString = this.$i18n_tc('NiotaClassic.GWMonitoring.minutes', durationMinutes, {
        n: durationMinutes
      });

      if (durationMinutes > 0 && durationHours < 24) {
        return "".concat(hoursString, " ").concat(minutesString);
      }

      return hoursString;
    },
    createOrUpdateGW: function createOrUpdateGW() {
      if (this.formItem.id) {
        if (!this.formItem.coordinates) {
          this.formItem.coordinates = {};
        }

        this.updateRequest();
      } else {
        this.createRequest();
      }
    },
    attachmentsUpdated: function attachmentsUpdated(data) {
      this.formItem.properties.attachments = data;
    },
    updateRequest: function updateRequest() {
      var _this4 = this;

      return ApiService.gwMgmtUpdate(this.formItem).then(function (response) {
        _this4.$snack(_this4.$i18n_t('NiotaClassic.GWMonitoring.snacks.updateSuccess'), 'success');

        _this4.$emit('updated', response);

        _this4.$emit('close');
      }).catch(function (error) {
        if (error.code === 'ECONNABORTED' || get(error, 'response.status') === 502) {
          _this4.$snack(_this4.$i18n_t('DigitalTwin.DigitalTwin.copy.timeoutSnack'), 'error');

          return;
        }

        var errorTranslateKey = "Error.".concat(get(error, 'response.data.message'));

        if (error.response && _this4.$i18n_t(errorTranslateKey) !== errorTranslateKey) {
          _this4.$snack(_this4.$i18n_t(errorTranslateKey), 'error');
        } else {
          _this4.$snack(_this4.$i18n_t('NiotaClassic.GWMonitoring.snacks.updateFailed'), 'error');
        }

        console.error(error);
      });
    },
    createRequest: function createRequest() {
      var _this5 = this;

      ApiService.gwMgmtCreate(this.formItem).then(function () {
        _this5.$emit('created');

        _this5.$emit('close');

        _this5.$snack(_this5.$i18n_t('NiotaClassic.GWMonitoring.snacks.createSuccess'), 'success');
      }).catch(function (error) {
        if (error.code === 'ECONNABORTED' || get(error, 'response.status') === 502) {
          _this5.$snack(_this5.$i18n_t('DigitalTwin.DigitalTwin.copy.timeoutSnack'), 'error');

          return;
        }

        var errorTranslateKey = "Error.".concat(get(error, 'response.data.message'));

        if (error.response && _this5.$i18n_t(errorTranslateKey) !== errorTranslateKey) {
          _this5.$snack(_this5.$i18n_t(errorTranslateKey), 'error');
        } else {
          _this5.$snack(_this5.$i18n_t('NiotaClassic.GWMonitoring.snacks.createFailed'), 'error');
        }

        console.error(error);
      });
    },
    filterAccounts: function filterAccounts(item, queryText) {
      return item.name.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1 || item.id.toString().toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1;
    },
    setAddressObject: function setAddressObject() {
      this.addressObject = {
        address: get(this.formItem, 'properties.formatted_address'),
        coordinates: get(this.formItem, 'coordinates.coordinates') || [null, null]
      };
    },
    addressSelected: function addressSelected(addressData) {
      set(this.formItem, 'properties.formatted_address', addressData.address);
      set(this.formItem, 'coordinates.coordinates', addressData.coordinates);
      this.formItem.properties = _objectSpread(_objectSpread({}, this.formItem.properties || {}), {}, {
        coordinateMode: addressData.pickedManualCoordinates ? 'manual' : 'auto'
      });
      this.setAddressObject();
    }
  }
};